const masteringPT = {
    "view": {
        "table": {
            "title": "Sua Lista de Masterização",
            "column": {
                "created_by": "Criado Por",
                "total_songs": "Número de Músicas",
                "mastered_songs": "Total de Músicas Masterizadas",
                "created": "Data de Criação",
                "action": "Ação"
            },
            "button": {
                "open": "ABRIR",
                "edit": "EDITAR",
                "export_csv": "Exportar CSV"
            },
            "placeholder": {
                "search": "Pesquisar..."
            }
        },
        "message": {
            "noAccess": "Você não tem acesso a este módulo, por favor entre em contato com a equipe de suporte para mais informações.",
            "subscriptionExpired": "Sua assinatura expirou. Por favor, <1>retome</1> sua assinatura para utilizar este recurso.",
            "subscriptionUpgrade": "Seu plano de assinatura atual não suporta este recurso. Por favor, <1>atualize</1> seu plano de assinatura para utilizar este recurso.",
            "noCredits": "Você não tem mais créditos de masterização de áudio. Saiba mais sobre créditos <1>aqui</1> e entre em contato com nossa equipe de suporte.",
            "learnMore": "Saiba tudo sobre Masterização de Áudio <1>aqui</1>. Para mais informações e <3>créditos</3>, entre em contato com nossa equipe de suporte."
        }
    },
    "add": {
        "form": {
            "step1": {
                "title": "Quantas músicas você deseja masterizar?",
                "label": {
                    "number_of_songs": "Número de Músicas"
                },
                "option": {
                    "songsCount": {
                        "selectNoOfSongs": "Selecione o número de músicas",
                        "song": "Música",
                        "songs": "Músicas"
                    }
                },
                "button": {
                    "continue": "Continuar"
                }
            },
            "step2": {
                "title": "Selecione suas músicas para masterização",
                "button": {
                    "save": "Salvar"
                }
            }
        },
        "message": {
            "uploadSuccess": "Músicas de Masterização de Áudio Carregadas com Sucesso!",
            "creationSuccess": "A Masterização de Áudio foi criada! Agora, por favor, selecione suas músicas na seção abaixo.",
            "error": "Ocorreu um erro. Por favor, tente novamente."
        },
        "modal": {
            "addMastering": {
                "header": "Tem certeza de que deseja adicionar nova masterização?",
                "body": "Nota: Isso resultará na dedução de {{credits}} créditos."
            },
            "saveMastering": {
                "header": "Tem certeza de que deseja salvar a Masterização de Áudio?",
                "body": "Nota: Certifique-se de carregar os arquivos de áudio corretos, pois eles não podem ser modificados após serem salvos."
            }
        }
    },
    "update": {
        "form": {
            "label": {
                "selectSongs": "Selecione suas músicas para masterização"
            },
            "button": {
                "save": "Salvar"
            }
        },
        "message": {
            "success": "Masterização de Áudio atualizada com sucesso!",
            "errorCantUpdate": "A Masterização de Áudio não pode ser atualizada após as músicas serem carregadas!",
            "errorMasteringDoesNotExist": "A masterização não pode ser atualizada, pois não existe!",
            "error": "Ocorreu um erro. Por favor, tente novamente."
        },
        "modal": {
            "saveMastering": {
                "header": "Tem certeza de que deseja salvar a Masterização de Áudio?",
                "body": "Nota: Certifique-se de carregar os arquivos de áudio corretos, pois eles não podem ser modificados após serem salvos."
            }
        }
    },
    "viewSongs": {
        "title": "Músicas de Masterização de Áudio",
        "table": {
            "column": {
                "name": "Nome",
                "preset": "Predefinição",
                "intensityAndLoudness": "Intensidade & Volume",
                "preview": "Pré-visualização",
                "master": "Masterizar",
                "previewResult": "Resultado da Pré-visualização",
                "masteringResult": "Resultado da Masterização",
                "mastered": "Masterizado",
                "action": "Ação"
            },
            "label": {
                "previewAttemptsLeft": "{{count}} Restantes",
                "notAvailable": "Não Disponível"
            },
            "button": {
                "generate": "Gerar",
                "edit": "Editar",
                "exportCsv": "Exportar CSV"
            },
            "option": {
                "preset": {
                    "acoustic": "Acústico",
                    "allGenres": "Todos os Gêneros",
                    "classical": "Clássico",
                    "clubHouseTechno": "Clube - House - Techno",
                    "edmMusic": "Música EDM",
                    "electronic": "Eletrônico",
                    "electronicRaw": "Eletrônico Cru",
                    "hipHop": "Hip Hop",
                    "hipHopBass": "Hip Hop Bass",
                    "popMusic": "Música Pop",
                    "popRnB": "Pop & RnB",
                    "rockMetal": "Rock & Metal",
                    "trap": "Trap",
                    "vocalFocused": "Focado em Vocais"
                }
            },
            "message": {
                "previewDownloadTooltip": "A pré-visualização está sendo gerada. Aguarde 5-6 minutos para que ela apareça.",
                "masteringDownloadTooltip": "A masterização está em processo. Aguarde 7-15 minutos para que ela apareça.",
                "alreadyMasteredTooltip": "Esta música já foi masterizada."
            }
        },
        "message": {
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!",
            "successMaster": "Música enviada para geração de Masterização!<br/>Nota: Verifique em alguns minutos, pois leva de 7 a 15 minutos para gerar a masterização.",
            "successPreview": "Música enviada para geração de Pré-visualização de Masterização!<br/>Nota: Verifique em alguns minutos, pois leva de 5 a 6 minutos para gerar a pré-visualização de masterização."
        },
        "modal": {
            "generateMastering": {
                "header": "Gerar Masterização",
                "body": "Tem certeza de que deseja gerar a masterização? Esta é uma ação irreversível! O resultado da masterização aparecerá dentro de 7-15 minutos.",
                "message": {
                    "success": "Música enviada para geração de Masterização!"
                }
            },
            "generateMasteringPreview": {
                "header": "Gerar Pré-visualização de Masterização",
                "body": "Tem certeza de que deseja gerar a pré-visualização de masterização? O resultado da pré-visualização aparecerá dentro de 5-6 minutos",
                "message": {
                    "success": "Música enviada para geração de Pré-visualização de Masterização!"
                }
            }
        }
    },
    "songParametersUpdate": {
        "title": "Editar Parâmetros da Música",
        "form": {
            "label": {
                "intensity": "Intensidade",
                "loudness": "Volume",
                "preset": "Predefinição"
            },
            "placeholder": {
                "preset": "Selecionar Predefinição"
            },
            "option": {
                "preset": {
                    "acoustic": "Acústico",
                    "allGenres": "Todos os Gêneros",
                    "classical": "Clássico",
                    "clubHouseTechno": "Clube - House - Techno",
                    "edmMusic": "Música EDM",
                    "electronic": "Eletrônico",
                    "electronicRaw": "Eletrônico Cru",
                    "hipHop": "Hip Hop",
                    "hipHopBass": "Hip Hop Bass",
                    "popMusic": "Música Pop",
                    "popRnB": "Pop & RnB",
                    "rockMetal": "Rock & Metal",
                    "trap": "Trap",
                    "vocalFocused": "Focado em Vocais"
                }
            },
            "button": {
                "submit": "Enviar"
            },
            "message": {
                "intensityTooltip": "A quantidade de dinâmica, EQ e processamento aplicados à sua música em relação à faixa geral e à predefinição selecionada. A utilização máxima ocorrerá em 100%. Recomendamos experimentar esta configuração para encontrar o ponto ideal que melhor se adapta a você.",
                "loudnessTooltip": "O nível de volume alvo integrado. Medido em unidades de volume relativas à escala completa (LUFS). Recomendamos experimentar esta configuração para encontrar o ponto ideal que melhor se adapta a você. Dependendo do estilo e gênero da sua música, os melhores resultados devem aparecer entre -15 e -9 db"
            }
        },
        "message": {
            "success": "Os parâmetros da música foram atualizados!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!",
            "songMastered": "Os parâmetros da música não podem ser atualizados após a música ter sido masterizada!"
        }
    },
    "songRow": {
        "label": {
            "songs": "Músicas",
            "name": "Nome",
            "genre": "Gênero",
            "preset": "Predefinição",
            "intensity": "Intensidade",
            "loudness": "Volume",
            "audioFile": "Arquivo de Áudio"
        },
        "placeholder": {
            "name": "ex. Nome da Música",
            "genre": "ex. Pop",
            "preset": "Selecionar Predefinição"
        },
        "option": {
            "preset": {
                "acoustic": "Acústico",
                "allGenres": "Todos os Gêneros",
                "classical": "Clássico",
                "clubHouseTechno": "Clube - House - Techno",
                "edmMusic": "Música EDM",
                "electronic": "Eletrônico",
                "electronicRaw": "Eletrônico Cru",
                "hipHop": "Hip Hop",
                "hipHopBass": "Hip Hop Bass",
                "popMusic": "Música Pop",
                "popRnB": "Pop & RnB",
                "rockMetal": "Rock & Metal",
                "trap": "Trap",
                "vocalFocused": "Focado em Vocais"
            }
        },
        "message": {
            "intensityTooltip": "A quantidade de dinâmica, EQ e processamento aplicados à sua música em relação à faixa geral e à predefinição selecionada. A utilização máxima ocorrerá em 100%. Recomendamos experimentar esta configuração para encontrar o ponto ideal que melhor se adapta a você.",
            "loudnessTooltip": "O nível de volume alvo integrado. Medido em unidades de volume relativas à escala completa (LUFS). Recomendamos experimentar esta configuração para encontrar o ponto ideal que melhor se adapta a você. Dependendo do estilo e gênero da sua música, os melhores resultados devem aparecer entre -15 e -9 db",
            "audioFileTooltip": "Os formatos de áudio suportados são: AAC, AIFF, FLAC, MP3, OPUS, VORBIS e WAV. Recomendamos fortemente o uso de tipos de arquivo sem perdas, como AIFF, FLAC ou WAV. Nossa ferramenta de masterização sempre retornará o mesmo tipo de arquivo que o arquivo original. Tenha em mente que você precisa de um arquivo WAV de 16 bits, 44,1 khz para a distribuição.",
            "errorSongNameRequired": "Por favor, insira o nome da música",
            "errorSongNameLength": "O nome da música não deve ter mais de 80 caracteres.",
            "errorGenreRequired": "Por favor, insira o gênero da música",
            "errorGenreLength": "O gênero da música não deve ter mais de 50 caracteres.",
            "errorPresetRequired": "A predefinição deve ser selecionada.",
            "errorAudioFileRequired": "Por favor, selecione o arquivo da música",
            "errorAudioFileValid": "Por favor, carregue um arquivo de áudio válido"
        }
    },
    "masteringConfirmModal": {
        "header": "Tem certeza de que deseja salvar a Masterização de Áudio?",
        "body": "Nota: Certifique-se de carregar os arquivos de áudio corretos, pois eles não podem ser modificados após serem salvos.",
        "button": {
            "cancel": "Cancelar",
            "confirm": "Confirmar"
        },
        "message": {
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
        }
    }
};

export default masteringPT;